import Container from 'components/Container'
import React from 'react'
import Styled from './styled'
import { ISkeletonItem } from './types'

export const SkeletonItem: React.FC<ISkeletonItem> = ({ className, $width, $round, $height, $size = 'medium' }) => (
	<Styled.Block $size={$size} $width={$width} $height={$height} $round={$round} className={className} />
)

export const SkeletonFormItem = () => (
	<Container space="xs" spaceDirection="vertical">
		<SkeletonItem $width={100} $height={25} $size="small" />
		<SkeletonItem />
	</Container>
)
